import { render } from "./ModelSelect.vue?vue&type=template&id=55a29b10&scoped=true"
import script from "./ModelSelect.vue?vue&type=script&lang=js"
export * from "./ModelSelect.vue?vue&type=script&lang=js"

import "./ModelSelect.vue?vue&type=style&index=0&id=55a29b10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a29b10"]])

export default __exports__